/**
 * Returns true if a value is either undefined, null, or an empty object, empty array, or an empty string.
 * Returns false for number values such as 0, 1, -0 and boolean values.
 *
 * @param value {any}
 * @returns {Boolean}
 */
const isEmpty = (value: any): boolean => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)
  );
};

export default isEmpty;
